import {Component, Input, OnInit} from '@angular/core';
import {
  GrantApplicationSubmittedReportResponse
} from "../../../../models/grantApplication/grantApplicationSubmittedReportResponse";
import {NgxSpinnerService} from "ngx-spinner";
import {GrantApplicationService} from "../../../../services/grantApplication.service";
import {GrantApplicationStatus} from "../application-detail.component";

@Component({
  selector: 'app-submitted-report',
  templateUrl: './submitted-report.html',
  styleUrls: ['./submitted-report.scss']
})
export class SubmittedReport implements OnInit{
  reportType: GrantApplicationSubmittedReportResponse[] = [];
  @Input() applicationId:string="";
  @Input() graintApplicationStaus!: GrantApplicationStatus;

  @Input() isReadOnly: boolean = false;

  constructor(
    private spinner: NgxSpinnerService,
    private grantApplication: GrantApplicationService,
  ) {

  }

  ngOnInit(): void {
    if (this.graintApplicationStaus === 'Approved' || this.isReadOnly) {
      this.spinner.show();
      this.loadTasks(this.applicationId)
        .finally(() => this.spinner.hide());
    }
  }





  loadTasks(appId: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.grantApplication.getReportType(appId).subscribe({
        next: (response) => {
          this.reportType = response.item ?? [];
          resolve();
        },
        error: (error) => {
          console.error('Error fetching tasks:', error);
          reject(error);
        },
      });
    });
  }

}
